import { Route, Routes } from "react-router-dom";
import { useSelector } from "react-redux";

import { selectors as subscriptionSelectors } from "../../subscription";
import Plan from "./plan/plan.component";
import Main from "./main/main.component";

const Subscription = () => {
    const subscription = useSelector( subscriptionSelectors.getSubscription );

    return (
        <Routes>
            <Route index element={ <Main/> }/>
            { !subscription.partnerId && <Route path={ "plans" } element={ <Plan/> }/> }
        </Routes>
    );
};

export default Subscription;